<template>
  <div class="view-container">
    <el-drawer :visible.sync="drawer" direction="rtl" size="50%" :modal-append-to-body="false" :before-close="handleClose" :title="openType == 1 ? $t('billingPage.billingAdd') : openType == 2 ? $t('billingPage.billingEdit'): $t('billingPage.billingView')">
      <BjDivider>{{ $t('ChannelManagement.new.title') }} </BjDivider>
      <el-form v-if="drawer" ref="form" label-position="top" :model="form" :disabled="openType==3" :rules="rules" label-width="160px" style="padding:16px;">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('billingPage.categoryCode')" prop="code">
              <BjInput v-model="form.code" :disabled="openType!=1" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('billingPage.categoryName')" prop="name">
              <BjInput v-model="form.name" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('billingPage.quotationGroup')" prop="group">
              <BjSelectLov v-model="form.group" lov-code="BILL_CATEGORY_GROUP" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('billingPage.SAPGroup')" prop="sapGroup">
              <BjSelectLov v-model="form.sapGroup" lov-code="BILL_SAP_GROUP" />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item :label="$t('billingPage.reportGroup')" prop="reportGroup">
              <BjSelectLov v-model="form.reportGroup" lov-code="BILL_REPORT_GROUP" />
            </el-form-item>
          </el-col> -->
        </el-row>
        <!-- <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('billingPage.standardPrice')" prop="standardPrice">
              <BjInput v-model="form.standardPrice" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('billingPage.standardCost')" prop="cost">
              <BjInput v-model="form.cost" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('billingPage.department')" prop="department">
              <BjSelectLov v-model="form.department" multiple :clearable="false" :option-list="departmentList" />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item :label="$t('billingPage.position')" prop="positionList">
              <BjInput v-model="positionListName" disabled :placeholder="$t('AddAThirdPartyAfterSalesOrder.button')">
                  <el-button slot="append" @click="addPosition">{{ $t('chooseText') }}</el-button>
              </BjInput>
            </el-form-item>
          </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="12*2">
            <el-form-item :label="$t('billingPage.tag')" prop="tag">
              <el-tag v-for="(tag, index) in dataTagsList" :key="index" closable :disable-transitions="false" size="medium" @close="onDEL(tag)">
                {{ tag }}
              </el-tag>
              <el-input v-if="inputVisible" ref="saveTagInput" v-model="tag" class="input-new-tag" size="medium" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
              </el-input>
              <el-button v-else class="button-new-tag" size="mini" @click="showInput">{{ $t('billingPage.createTag') }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('billingPage.description')" prop="description">
              <BjInput v-model="form.description" type="textarea" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('billingPage.Logic')" prop="logic">
              <BjInput v-model="form.logic" type="textarea" :rows="5" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="foot">
        <el-button type="danger" @click="handleClose">{{ $t('cancelText') }}</el-button>
        <el-button type="primary" :disabled="openType==3" @click="onComfirm">{{ $t('okText') }}</el-button>
      </div>
    </el-drawer>

    <dialogData ref="dialogDataRef" @submit="onSubmit" :positionList="positionList" :checkList="checkList" />
  </div>
</template>
<script>
import moment from 'moment';
import dialogData from './dialogData';
import { BILLING_CATEGORI_TYPE, BILLING_CATEGORI_REPORTGROUP } from '@/utils/constants';
const getDefaultForm = () => {
  return {
    id: null,
    code: null,
    name: null,
    group: null,
    sapGroup: null,
    effectiveDate: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
    tag: [],
    standardPrice: null,
    cost: null, // 状态默认启用
    description: null,
    department: [],
    positionList: []
  };
};
export default {
  components: {
    dialogData
  },
  props: {
      positionList: {
          type: Array,
          default: [],
      },
      departmentList: {
          type: Array,
          default: [],
      },
  },
  data() {
    return {
      BILLING_CATEGORI_TYPE,
      BILLING_CATEGORI_REPORTGROUP,
      openType: 1,
      // 表单参数
      drawer: false,
      form: getDefaultForm(),
      // 标签
      tag: '',
      dataTagsList: [],
      inputVisible: false,
      // 表单校验
      rules: {
        type: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        code: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        name: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        enName: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        effectiveDate: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        group: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        sapGroup: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        reportGroup: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        unit: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        sectionMin: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        standardPrice: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        cost: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        department: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
        positionList: [{ required: true, message: this.$t('inputText'), trigger: 'blur' }],
      },
      positionListName: '',
      checkList: []
    };
  },
  methods: {
    onSubmit(val){
      this.form.positionList = val
      const name = this.form.positionList.map(item=> item.name);
      this.positionListName = name.join(',')
      this.checkList = name
    },
    addPosition(){
      this.$refs.dialogDataRef.dialogVisible = true;
    },
    // 标签
    onDEL(tag) {
        this.dataTagsList.splice(this.dataTagsList.indexOf(tag), 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      const inputValue = this.tag;
      if (inputValue) {
        this.dataTagsList.push(inputValue);
        this.form.tag = this.dataTagsList;
      }
      this.inputVisible = false;
      this.tag = '';
    },
    // 确定按钮
    onComfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.form.tag = this.dataTagsList.join(',');
          const obj = Object.assign({}, this.form);
          this.$emit('handleConfirm', obj);
          this.hide();
        }
      });
    },
    // 弹窗关闭
    hide() {
      this.drawer = false;
    },
    /** 关闭弹窗 */
    handleClose() {
      this.hide();
      this.form = getDefaultForm();
      this.positionListName = ''
      this.checkList = []
      this.dataTagsList = [];
    },
  },
};
</script>
<style lang="scss">
.el-tag {
  margin: 6px;
}
::v-deep .el-checkbox__label {
  width: 125px;
  height: 30px;
}
.foot {
  text-align: center;
  .el-button {
    width: 120px;
  }
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
